const ImageBanner = ({ imgUrl, text }) => {

    return (
        <div className="banner d-flex align-items-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + imgUrl})` }}>
            <div className="bg-custom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mx-auto">
                            <div className="banner-area text-center pt-4 pb-4">
                                <h2 className="mt-2 mb-4 banner-title"><strong>{text}</strong> </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImageBanner